export const LocalStorageKeys = {
    NOMINAL_TABUNGAN : "nominal_tabungan"
}